import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ConverterService,
  InterceptorUtil,
  Occ,
  OccEndpointsService,
  OCC_USER_ID_ANONYMOUS,
  USE_CLIENT_TOKEN,
} from '@spartacus/core';
import { Observable } from 'rxjs';
import { CheckoutAdapter, CheckoutDetails } from '../../core';
import { ORDER_NORMALIZER, Order } from '@spartacus/order/root';

@Injectable()
export class OccCheckoutAdapter implements CheckoutAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) {}

  protected getPlaceOrderEndpoint(userId: string, cartId: string, termsChecked: string): string {
    return this.occEndpoints.buildUrl('placeOrder', {
      urlParams: { userId },
      queryParams: { cartId, termsChecked },
    });
  }

  protected getRemoveDeliveryAddressEndpoint(userId: string, cartId: string): string {
    return this.occEndpoints.buildUrl('removeDeliveryAddress', {
      urlParams: {
        userId,
        cartId,
      },
    });
  }

  protected getClearDeliveryModeEndpoint(userId: string, cartId: string): string {
    return this.occEndpoints.buildUrl('clearDeliveryMode', {
      urlParams: { userId, cartId },
    });
  }

  protected getClearCollectLocationEndpoint(userId: string, cartId: string): string {
    return this.occEndpoints.buildUrl('collectLocation', {
      urlParams: { userId, cartId },
    });
  }

  protected getLoadCheckoutDetailsEndpoint(userId: string, cartId: string): string {
    return this.occEndpoints.buildUrl('loadCheckoutDetails', {
      urlParams: {
        userId,
        cartId,
      },
    });
  }

  protected getSetOldApplianceRemovalEndpoint(userId: string, cartId: string, applianceRemoval: boolean): string {
    return this.occEndpoints.buildUrl('oldApplianceRemoval', {
      urlParams: { userId, cartId, applianceRemoval },
    });
  }

  public placeOrder(userId: string, cartId: string, termsChecked: boolean): Observable<Order> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }

    return this.http
      .post<Occ.Order>(this.getPlaceOrderEndpoint(userId, cartId, termsChecked.toString()), {}, { headers })
      .pipe(this.converter.pipeable(ORDER_NORMALIZER));
  }

  loadCheckoutDetails(userId: string, cartId: string): Observable<CheckoutDetails> {
    return this.http.get<CheckoutDetails>(this.getLoadCheckoutDetailsEndpoint(userId, cartId));
  }

  clearCheckoutDeliveryAddress(userId: string, cartId: string): Observable<any> {
    return this.http.delete<any>(this.getRemoveDeliveryAddressEndpoint(userId, cartId));
  }

  clearCheckoutDeliveryMode(userId: string, cartId: string): Observable<any> {
    return this.http.delete<any>(this.getClearDeliveryModeEndpoint(userId, cartId));
  }

  clearCollectLocation(userId: string, cartId: string): Observable<any> {
    return this.http.delete<any>(this.getClearCollectLocationEndpoint(userId, cartId));
  }

  setOldApplianceRemoval(userId: string, cartId: string, applinceRemoval: boolean): Observable<any> {
    return this.http.post<any>(this.getSetOldApplianceRemovalEndpoint(userId, cartId, applinceRemoval), {});
  }
}
